/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import classnames from 'classnames';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import LinkJump from '@gp/components/LinkJump';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import { queryJumpable } from '@gp/utils/common';

import '@gp/assets/css/pages/prejectsItems.scss';

export default function ProjectItem(props) {
  const { style, className, data, bubble, toDetails, children } = props;

  const { project: content, cover } = data ?? {};
  const url = toDetails?.(data, null, false);

  const contentRef = useRef(null);

  return (
    <div
      style={{ ...style, cursor: 'pointer' }}
      className={classnames('dbg-prejects dbg-project-item', className)}
      onClick={(e) => {
        if (!queryJumpable(e)) return;
        toDetails?.(data, e);
      }}
    >
      <LinkJump style={{ display: 'flex' }} stopPropagation={false} url={url}>
        <GeneralImageNew className="dbg-prejects-img" domain="game" width={54} height={54} src={cover} />
      </LinkJump>
      <div className="dbg-prejects-text">
        <LinkJump
          className="dbg-prejects-context"
          // style={{
          //   textDecoration: 'none',
          //   color: '#444',
          //   display: 'flex',
          //   maxWidth: '100%',
          // }}
          stopPropagation={false}
          url={url}
        >
          <div ref={contentRef} className="dbg-prejects-text-content">
            <EllipsisTextBubble
              className="dbg-prejects-title"
              text={content}
              ellipsisLineClamp={2}
              customBubbleContent={bubble}
            />
          </div>
        </LinkJump>
        <div className="dbg-prejects-text-slot">{children}</div>
      </div>
    </div>
  );
}
